import type { ApprovalType } from '../types/ApprovalType';
import { unreachableFallback } from './unreachableFallback';

export const canRequestChanges = ({
  approvalType,
}: {
  approvalType: ApprovalType;
}): boolean => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'DEAL':
    case 'KNOWLEDGE_ARTICLE':
    case 'SOCIAL_BROADCAST':
      return true;
    case 'QUOTE':
    case 'CONNECTED_APP':
      return false;
    default:
      return unreachableFallback(approvalType, false);
  }
};
